module.exports = __webpack_public_path__ + "img/yawning.dd6ddc4c.png";